<template>
  <span class="app-icon" aria-hidden="true">{{ glyph }}</span>
</template>

<script>
const glyphs = {
  home: '⌂',
  'book-open': '▰',
  wrench: '⚒',
  user: '●',
  github: '⌘',
  tv: '▣',
  bell: '♦',
  mail: '✉',
  twitter: '◆',
  send: '➤',
  feather: '❧',
  image: '▧',
  cloud: '☁',
  music: '♪',
  planet: '◌',
  bookmark: '▤',
  flame: '♦',
  'message-circle': '•••',
  hourglass: '⌛',
  clock: '◷',
  sun: '☼',
  sparkle: '✦',
  moon: '☾'
};

export default {
  name: 'AppIcon',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  computed: {
    glyph() {
      return glyphs[this.name] || '✦';
    }
  }
};
</script>
